import { css } from '@emotion/react'

import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        dialogContentRoot: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
            flex-direction: column;
        `,
        dialogActionsRoot: common.dialogActionsRoot,
        dialogTitle: css` padding: 22px 20px `,
        titleHeader: css`
            padding: 19px 26px 17px 26px;
            ${custom.dialogTitle};
        `,
    }
}

export default styles
